import { setStorage } from '@lhb/cache';
import { isNotEmptyAny } from '@lhb/func';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  filterParams: {};
}

const initialState: InitStata = {
  filterParams: {},
};

const customerSlice = createSlice({
  name: 'sitemap',
  initialState,
  reducers: {
    submitFilterParams: (state = initialState, action: PayloadAction<any>) => {
      if (isNotEmptyAny(action.payload)) {
        setStorage('filterMapParams', action.payload);
      }
      state.filterParams = action.payload;
    },
  },
});

// 导出action
export const { submitFilterParams } = customerSlice.actions;

export default customerSlice.reducer;
